// extracted by mini-css-extract-plugin
export default {"postcode-overlay":"postCode_postcode-overlay__y9A65","postcode-modal":"postCode_postcode-modal__cs9YL","postcode-modal-content":"postCode_postcode-modal-content__v4VjB"};